module.exports = __webpack_public_path__ + "img/Sales_Icon.94277684.png";